<template>
  <el-card class="campaign-list">
    <el-row :gutter="20" class="search-wrap">
      <el-col :md="3" class="search-item">
        <el-select v-model="params.status" :placeholder="$t('messages.myCampaign.list5')" @keyup.native="getList" clearable>
          <el-option
            v-for="(item, i) in asoGrowOption.asogrow_campaign_status"
            :key="i"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :md="3" class="search-item">
        <el-select
          v-model="params.business_type"
          :placeholder="$t('messages.myCampaign.list6')"
          @keyup.native="getList"
          clearable
        >
          <el-option
            v-for="(item, i) in asoGrowOption.asogrow_price_business_type"
            :key="i"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :md="4" class="search-item" v-if="isAgent">
        <el-input
          v-model="params.developer_name"
          :placeholder="$t('messages.myCampaign.list7')"
          style="min-width: 100px;"
        ></el-input>
      </el-col>
      <el-col :md="4" class="search-item">
        <el-input
          v-model="params.cpid"
          :placeholder="$t('messages.myCampaign.list8')"
          style="min-width: 115px;"
        ></el-input>
      </el-col>
      <el-col :md="3" class="search-item">
        <el-input
          v-model="params.package"
          :placeholder="$t('messages.myCampaign.list9')"
          style="min-width: 100px;"
        ></el-input>
      </el-col>
      <el-col :md="7" class="search-item-btn" style="width: 342px;">
        <el-button type="primary" @click="getList">{{$t('messages.myCampaign.list43')}}</el-button>
        <el-button type="primary" @click="add" class="create-btn">{{$t('messages.myCampaign.list44')}}</el-button>
        <el-button type="primary" @click="exportAll">{{$t('messages.myCampaign.list45')}}</el-button>
      </el-col>
    </el-row>
    <el-row class="mt-3 tableRow">
      <el-table
        v-loading="loading"
        :empty-text="$t('messages.myCampaign.list10')"
        :fit="true"
        border
        :data="list"
        class="campaignListTable"
      >
        <el-table-column type="expand" class="demo-table-expand-row" :width="32" v-if="showMobile">
          <template slot-scope="scope">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item :label="$t('messages.myCampaign.list11')">
                <span>
                  {{
                    newTypes.includes(scope.row.business_type) || isSocialMediaType(scope.row.business_type)
                      ? scope.row.reviewer_name
                      : scope.row.app_name
                  }}
                </span>
              </el-form-item>
              <el-form-item :label="$t('messages.myCampaign.list12')">
                <span
                  v-if="scope.row.cp_type === 0"
                  :title="
                    showLabel(scope.row.business_type, asoGrowOption.asogrow_price_business_type)
                  "
                >
                  {{
                    showLabel(scope.row.business_type, asoGrowOption.asogrow_price_business_type)
                  }}
                </span>
                <span v-else :title="$t('messages.myCampaign.list13')">
                  {{$t('messages.myCampaign.list13')}}
                </span>
              </el-form-item>
              <el-form-item :label="$t('messages.home.tip52')" >
                <span>
                  {{ newTypes.includes(scope.row.business_type) ? 'All' : scope.row.country }}
                </span>
              </el-form-item>
              <el-form-item :label="$t('messages.myCampaign.list14')">
                <span>{{ moment(scope.row.start).format('YYYY-MM-DD') }}~{{ moment(scope.row.end).format('YYYY-MM-DD') }}</span>
              </el-form-item>
              <el-form-item :label="$t('messages.myCampaign.list15')">
                <span>{{ scope.row.price | dataFormat }}</span>
              </el-form-item>
              <el-form-item :label="$t('messages.myCampaign.list16')">
                <template v-if="originalCountry.includes(scope.row.country)">
                  <el-button
                    type="text"
                    @click="showCostReport(scope.row)"
                    v-if="scope.row.cost != 0"
                    style="text-align: left;padding-left: 0;"
                  >
                    <a class="cost-link">{{ scope.row.cost | dataFormat }}</a>
                  </el-button>
                  <span v-else>0</span>
                </template>
                <template v-else>
                  <el-button
                    type="text"
                    @click="showCostReport(scope.row)"
                    v-if="scope.row.report_link"
                    style="text-align: left;padding-left: 0;"
                  >
                    <a class="cost-link">{{$t('messages.myCampaign.list17')}}</a>
                  </el-button>
                  <el-button
                    type="text"
                    @click="showCostReport(scope.row)"
                    v-else-if="scope.row.cost != 0"
                    style="text-align: left;padding-left: 0;"
                  >
                    <a class="cost-link">{{ scope.row.cost | dataFormat }}</a>
                  </el-button>
                  <span v-else class="cost-link-d">0</span>
                </template>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list19')" :min-width="showMobile ? 48 : 100" align="center">
          <template slot-scope="scope">
            <template v-if="isSocialMediaType(scope.row.business_type)">
              <img
                :src="scope.row.icon"
                :class="showMobile ? 'icon1' : 'icon'"
                alt="icon"
                v-if="scope.row.icon"
              />
              <img
                :src="scope.row.avatar"
                :class="showMobile ? 'icon1' : 'icon'"
                alt="icon"
                v-else-if="scope.row.avatar"
              />
              <p class="img-d" v-else>--</p>
            </template>
            
            <img
              :src="newTypes.includes(scope.row.business_type) ? scope.row.avatar : scope.row.icon"
              :class="showMobile ? 'icon1' : 'icon'"
              alt="icon"
              v-else
            />
          </template>
        </el-table-column>
      
        <el-table-column :label="$t('messages.myCampaign.list8')" :min-width="showMobile ? 68 : 120" align="center">
          <template slot-scope="scope">
            <p
              @click="showCampaignDetail(scope.row.id)"
              style="color: #1861F2;font-size: 14px;cursor: pointer;"
            >
              {{ scope.row.id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list7')" min-width="150" align="center" v-if="isAgent && !showMobile">
          <template slot-scope="scope">
            <p>
              {{ scope.row.developer_name || '--' }}
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list11')" min-width="160" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            {{
              newTypes.includes(scope.row.business_type) || isSocialMediaType(scope.row.business_type)
                ? scope.row.reviewer_name
                : scope.row.app_name
            }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list12')" min-width="180" align="center" v-if="!showMobile">
          <span
            slot-scope="scope"
            v-if="scope.row.cp_type === 1"
            :title="$t('messages.myCampaign.list13')"
          >
           {{$t('messages.myCampaign.list13')}}
          </span>
          <span
            slot-scope="scope"
            v-else
            :title="showLabel(scope.row.business_type, asoGrowOption.asogrow_price_business_type)"
          >
            {{ showLabel(scope.row.business_type, asoGrowOption.asogrow_price_business_type) }}
          </span>
        </el-table-column>
        <el-table-column
          prop="country"
          :label="$t('messages.home.tip52')"
          min-width="90"
          align="center"
          v-if="!showMobile"
        >
          <template slot-scope="scope">
            {{ newTypes.includes(scope.row.business_type) ? 'All' : scope.row.country }}
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          :label="$t('messages.myCampaign.list15')"
          min-width="90"
          align="center"
          v-if="!showMobile"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.price | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list16')" min-width="120" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            <template v-if="originalCountry.includes(scope.row.country)">
              <el-button
                type="text"
                @click="showCostReport(scope.row)"
                v-if="scope.row.cost != 0"
                style="text-align: center;padding: 0;"
              >
                <a class="cost-link">{{ scope.row.cost | dataFormat }}</a>
              </el-button>
              <span v-else :title="[4,8].includes(scope.row.status) ? $t('messages.myCampaign.list52') : ''" class="cost-link-d">0</span>
            </template>
            <template v-else>
              <el-button
                type="text"
                @click="showCostReport(scope.row)"
                v-if="scope.row.report_link"
                style="text-align: center;padding: 0;"
              >
                <a class="cost-link">{{ $t('messages.myCampaign.list17') }}</a>
              </el-button>
              <el-button
                type="text"
                @click="showCostReport(scope.row)"
                v-else-if="scope.row.cost != 0"
                style="text-align: center;padding: 0;"
              >
                <a class="cost-link">{{ scope.row.cost | dataFormat }}</a>
              </el-button>
              <span v-else :title="[4,8].includes(scope.row.status) ? $t('messages.myCampaign.list52') : ''" class="cost-link-d">0</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list21')" min-width="150" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            <div v-for="(value, key) in renderKeysInOrder(scope.row.total_cap_v2,scope.row.cp_type)" :key="key"> 
              <p v-if="scope.row.cp_type === 0">{{ value }}</p> 
              <p v-else style="text-align: left;">{{ keys[key] }}: {{ value }}</p> 
            </div>  
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list4')" min-width="150" align="center" v-if="!showMobile">
          <template slot-scope="scope">
            <template v-if="JSON.stringify(scope.row.consumed_cap_v2) !== '{}'">
              <div v-for="(value, key) in renderKeysInOrder(scope.row.consumed_cap_v2,scope.row.cp_type)" :key="key"> 
                <p v-if="scope.row.cp_type === 0">{{ value }}</p> 
                <p v-else style="text-align: left;">{{ keys[key] }}: {{ value }}</p> 
              </div>  
            </template>
            <p v-else>0</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list5')" align="center" :min-width="showMobile ? 67 : 100">
          <template slot-scope="scope">
            <p>{{ showLabel(scope.row.status, asoGrowOption.asogrow_campaign_status) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="end"
          :label="$t('messages.myCampaign.list14')"
          min-width="200"
          align="center"
          v-if="!showMobile"
        >
          <template slot-scope="scope">
            <span>{{ moment(scope.row.start).format('YYYY-MM-DD') }} ~ {{ moment(scope.row.end).format('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('messages.myCampaign.list42')"
          fixed="right"
          align="center"
          :min-width="showMobile ? 70 : 200"
        >
          <template slot-scope="scope">
            <div class="actionWrap">
              <el-link
                type="primary"
                @click="repeat(scope.row)"
                v-if="showAction(scope.row.status, 'repeat')"
              >
               {{ $t('messages.myCampaign.list1') }}
              </el-link>
              <el-link
                style="margin-left: 16px;"
                type="primary"
                @click="changeStatus(scope.row, 4)"
                v-if="showAction(scope.row.status, 'active')"
              >
                Active
              </el-link>
              <el-link
                type="primary"
                style="margin-left: 16px;"
                @click="changeStatus(scope.row, 5)"
                v-if="
                  showAction(scope.row.status, 'pause') &&
                    originalCountry.includes(scope.row.country)"
              >
              {{ $t('messages.myCampaign.list2') }}
              </el-link>
              <el-link
                type="primary"
                style="margin-left: 16px;"
                @click="changeStatus(scope.row, 6)"
                v-if="showAction(scope.row.status, 'cancel')" 
              >
                {{ $t('messages.myCampaign.list3') }}
              </el-link>
              <template v-if="showAction(scope.row.status, 'promote')">
                <el-tooltip
                  id="my-tooltip"
                  :hide-after="0"
                  manual
                  :value="scope.row.id === showTipId"
                  :content="$t('messages.myCampaign.list37')"
                  placement="bottom"
                  popper-class="dan"
                >
                  <div>
                    <el-link
                      type="primary"
                      v-if="showAction(scope.row.status, 'promote')"
                      @click="promoteCheck(scope.row)"
                    >
                    {{ $t('messages.myCampaign.list18') }}
                    </el-link>
                  </div>
                </el-tooltip>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <pagination :page="page" @sizeChange="getList" @currentChange="getList"></pagination>

    <el-dialog
      class="cost-report"
      :title="`Report of Campaign(${costReport.id}) ${costReport.app_name}`"
      :visible.sync="costReportVisible"
      width="600px"
    >
      <div v-loading="costReportLoading" v-if="reportType === 0">
        <table>
          <thead>
            <th>{{ $t('messages.myCampaign.list20') }}</th>
            <th>{{ $t('messages.myCampaign.list16') }}</th>
            <th>{{ $t('messages.myCampaign.list21') }}</th>
          </thead>
          <tbody>
            <template v-if="costPopRunType === 1">
              <tr>
                <td>{{ showLabel(costPopBusinessType, asoGrowOption.asogrow_price_business_type) }}</td>
                <td>{{ costReportData.consumed_cap[offlineTypesRow[costPopBusinessType]] }}</td>
                <td>{{ costReportData.total_cap[offlineTypesRow[costPopBusinessType]] }}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td>Install,Open</td>
                <td>{{ costReportData.consumed_cap.download }}</td>
                <td>{{ costReportData.total_cap.download }}</td>
              </tr>
              <tr>
                <td>5 Stars Rate</td>
                <td>{{ costReportData.consumed_cap.rating }}</td>
                <td>{{ costReportData.total_cap.rating }}</td>
              </tr>
              <tr>
                <td>{{$t('messages.createCampaign.create71')}}</td>
                <td>{{ costReportData.consumed_cap.review }}</td>
                <td>{{ costReportData.total_cap.review }}</td>
              </tr>
              <tr>
                <td>{{$t('messages.createCampaign.create64')}}</td>
                <td>{{ costReportData.consumed_cap.custom_review }}</td>
                <td>{{ costReportData.total_cap.custom_review }}</td>
              </tr>
              <tr>
                <td>Likes to Review</td>
                <td>{{ costReportData.consumed_cap.like }}</td>
                <td>{{ costReportData.total_cap.like }}</td>
              </tr>
              <tr>
                <td>Keyword search and install</td>
                <td>{{ costReportData.consumed_cap.search_download }}</td>
                <td>{{ costReportData.total_cap.search_download }}</td>
              </tr>
              <!-- <tr>
                <td>Instagram Follow</td>
                <td>{{ costReportData.consumed_cap.instagram_follow }}</td>
                <td>{{ costReportData.total_cap.instagram_follow }}</td>
              </tr>
              <tr>
                <td>Instagram Post Like</td>
                <td>{{ costReportData.consumed_cap.instagram_post_like }}</td>
                <td>{{ costReportData.total_cap.instagram_post_like }}</td>
              </tr>
              <tr>
                <td>Youtube Subscribe</td>
                <td>{{ costReportData.consumed_cap.youtube_subscribe }}</td>
                <td>{{ costReportData.total_cap.youtube_subscribe }}</td>
              </tr>
              <tr>
                <td>Youtube Comment</td>
                <td>{{ costReportData.consumed_cap.youtube_comment }}</td>
                <td>{{ costReportData.total_cap.youtube_comment }}</td>
              </tr> -->
            </template>
          </tbody>
        </table>
        <p class="cost-report-zhekou" v-if="costReportData.discount_type && ![100,0].includes(popDiscount) && popDiscount > 0">
          <span>*</span>
          <span>
            {{ $t('messages.myCampaign.list41') }} {{ popDiscount }}%.
          </span>
        </p>
        <template v-if="costReportData.use_total_price_discount !== 1 && costPopRunType === 0">
          <div class="mt-4 export-area2" v-for="(value, key) in costReportData.unit_price_process_dict" :key="key">
            <span v-if="comboType === 0">{{$t('messages.createCampaign.create25')}}:</span>
            <span v-else>{{ keys[key] }}:</span>
            <span>{{ value }}</span>
          </div>
        </template>
        <div class="mt-4 export-area2" v-for="(value, key) in costReportData.consumption_process_dict">
          <span>{{ $t('messages.myCampaign.list16') }}:</span>
          <span>{{ value }}</span>
        </div>
        <div class="mt-4 export-area mb-4">
          {{ $t('messages.myCampaign.list46') }}:
          <el-button
            type="primary"
            :disabled="!costReportData.file_url"
            @click="exportData(costReportData.file_url)"
          >
          {{ $t('messages.myCampaign.list45') }}
          </el-button>
        </div>
      </div>
      <div class="mb-4" style="text-align: center;" v-else>
          {{ $t('messages.myCampaign.list47') }}:
        <el-button type="primary" @click="exportDatarReport">
          {{ $t('messages.myCampaign.list45') }}
        </el-button>
      </div>
      <div>
        <template v-if="!isOfflineTypeComputed">
          <p class="mb-2">{{ $t('messages.myCampaign.list57') }}{{ $t('messages.other.other2') }}</p>
          <p class="mb-2">{{ $t('messages.other.other3') }}</p>
          <p class="mb-2">{{ $t('messages.other.other4') }}</p>
        </template>
        <p v-if="reportType === 0">{{ $t('messages.myCampaign.list51') }}</p>
      </div>
      <div class="footer" slot="footer">
        <el-button type="button" @click="costReportVisible = false">{{ $t('messages.myCampaign.list53') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="campaign-confirm"
      :title="$t('messages.myCampaign.list38')"
      :visible.sync="confirmVisible"
      width="645px"
    >
      <div class="campaign-info">
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list19') }}:</div>
          <div class="value">
            <img :src="promoteCampaign.icon" alt="icon" width="32" height="32" />
          </div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list11') }}:</div>
          <div class="value">{{ promoteCampaign.app_name }}</div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list14') }}:</div>
          <div>
            <div class="value">
              <span style="color:#ffa922;display:inline-block;">
                {{ promoteCampaign.start.substr(0, 10) }}
              </span>
              <span>- {{ promoteCampaign.end.substr(0, 10) }}</span>
            </div>
            <p class="tip-p">
              {{
                rightNow
                  ? `(${$t('messages.other.other38')})`
                  : `(${$t('messages.myCampaign.list39')} ${promoteCampaign.start} ${$t('messages.myCampaign.list40')})`
              }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list12') }}:</div>
          <div class="value">
            {{
              showLabel(promoteCampaign.business_type, asoGrowOption.asogrow_price_business_type)
            }}
          </div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list21') }}:</div>
          <div class="value">{{ sumTotalCap() }}</div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list22') }}:</div>
          <div class="value">{{ promoteCampaign.price }}</div>
        </div>
      </div>
      <div class="balance-tips" v-if="!balanceNotEnough">
        <p>{{ $t('messages.myCampaign.list23') }}</p>
        <p>{{ $t('messages.myCampaign.list24') }}, ${{ promoteCampaign.price }} {{ $t('messages.myCampaign.list25') }}</p>
      </div>
      <div class="balance-tips" v-if="balanceNotEnough">
        <p>{{ $t('messages.myCampaign.list23') }}</p>
        <p>{{ $t('messages.myCampaign.list24') }}, {{ $t('messages.myCampaign.list26') }}</p>
      </div>

      <div class="footer" slot="footer">
        <el-button type="primary" @click="promoteCreate" v-if="!balanceNotEnough">
          {{ $t('messages.myCampaign.list27') }}
        </el-button>
        <el-button type="primary" @click="goDeposit" v-if="balanceNotEnough">
          {{ $t('messages.myCampaign.list28') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-success" :title="$t('messages.createCampaign.create155')" :visible.sync="successVisible" width="600px">
      <div class="success-content">
        <p class="icon-success-box">
          <i class="iconfont icon-circle-check"></i>
        </p>
        <p class="success-text">
          {{ $t('messages.myCampaign.list29') }}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="viewCampaignList">{{ $t('messages.myCampaign.list30') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-fail" :title="$t('messages.deposit.deposit56')" :visible.sync="failVisible" width="600px">
      <div class="fail-content">
        <p class="icon-fail-box">
          <i class="iconfont icon-circle-close"></i>
        </p>
        <p class="fail-text">{{$t('messages.myCampaign.list31')}}</p>
        <p class="fail-text">
          {{$t('messages.myCampaign.list32')}}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="failVisible = false">Close</el-button>
      </div>
    </el-dialog>
    <el-dialog class="success-confirm" :visible.sync="successVisible2" width="600px" height="320px">
      <el-result icon="success">
        <template slot="title">
          <p class="tip">{{$t('messages.myCampaign.list33')}}</p>
        </template>
        <template slot="subTitle">
          <p class="tip2">{{$t('messages.myCampaign.list34')}}</p>
        </template>
        <template slot="extra">
          <el-button type="primary" @click="handleVisible">{{$t('messages.myCampaign.list55')}}</el-button>
        </template>
      </el-result>
    </el-dialog>
    <el-dialog class="info-confirm" :visible.sync="infoVisible" width="600px" height="320px">
      <el-result icon="success">
        <template slot="title">
          <p class="tip">{{$t('messages.myCampaign.list56')}}</p>
        </template>
        <template slot="subTitle">
          <p style="margin-bottom: 8px;">{{$t('messages.myCampaign.list35')}}</p>
          <p>
            <!-- href="skype:live:.cid.3491d19d64694602?chat" -->
            <a class="guide-a" href="https://teams.live.com/l/invite/FEAOtIKX0rDmnGUuwE">
              <span>Teams: mrk@youmi.net</span>
            </a>
            <span>|</span>
            <a class="guide-a" href="mailto:mrk@youmi.net">
              <span>Email: mrk@youmi.net</span>
            </a>
            <span>|</span>
            <a class="guide-a" href="https://wa.me/8618028539642">
              <span>WhatsApp: +86 18028539642</span>
            </a>
          </p>
        </template>
        <template slot="extra">
          <el-button type="primary" @click="handleVisible">{{$t('messages.myCampaign.list55')}}</el-button>
        </template>
      </el-result>
    </el-dialog>

    <el-dialog
      class="cancel-confirm"
      :visible.sync="cancelVisible"
      width="604px"
      height="320px"
      :title="$t('messages.other.other36')"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="cancelCampaign"
        :model="form"
        :rules="rules"
        label-width="50px"
        style="padding: 0 20px;"
      >
        <el-form-item :label="$t('messages.support.support32')" prop="cancel_reason" class="cancel_reason">
          <el-input v-model="form.cancel_reason" type="textarea"></el-input>
        </el-form-item>
        <p style="color:#aaaaaa;margin-top: 38px;">
          {{$t('messages.myCampaign.list55')}}
        </p>
      </el-form>
      <div class="footer" slot="footer">
        <el-button @click="cancelVisible = false">{{ $t('messages.other.other31') }}</el-button>
        <el-button @click="handleSubmit" type="primary" :disabled="btnDisabled">{{ $t('messages.deposit.deposit43') }}</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import moment from 'moment'
import { asogrowCN } from '@/js/varible'
import { timezone } from '@/js/varible'
import pagination from '../../components/pagination.vue'
import { throttleFn } from '@/js/common'
export default {
  components: {
    pagination,
  },
  data() {
    return {
      moment,
      warnTip:'If there is no data for more than a day, please contact us. Data may be delayed',
      originalCountry: ['ID', 'IN', 'PH','US','NG','VN','TH','BR','MX','MY','BD','PK'],
      rightNow: false,
      params: {
        status: '',
        business_type: '',
        cpid: '',
        package: '',
        developer_name:'',
      },
      loading: false,
      scroll_target: '.el-main',
      list: [],
      page: {
        tot: 0,
        cur: 1,
        per: 20,
      },
      costReportVisible: false,
      costPopBusinessType: '',
      costPopMediaPlatform: '',
      costPopMediaPlatTarget: '',
      costReportLoading: false,
      costReport: {
        id: '',
        app_name: '',
      },
      costReportData: {
        cap: {},
        total: {},
        cost: {},
        file_url: '',
        discount_type:0,
        cap_int:{},
        unit_price_after_discount:{},
        unit_price_before_discount:{},
        consumed_cap: {},
        total_cap: {},
        consumption_process_dict:{},
        unit_price_process_dict:{},
        use_total_price_discount: 0,
      },
      costReportLink: '',
      asoGrowOption: {},
      asoGrowOptionEN:{},
      asogrowCN,
      // promote支付流程
      promoteCampaign: {
        info: [],
        start: '',
        end: '',
      },
      checkCampaign: {},
      confirmVisible: false,
      balanceNotEnough: false,
      successVisible: false,
      failVisible: false,
      successVisible2: false,
      infoVisible: false,
      showTipId: null,
      timezoneOptions: this.initSelectOptions(timezone),
      cancelVisible: false,
      form: {
        cancel_reason: '',
      },
      rules: {
        cancel_reason: [
          this.createRequiredRule(this,'messages.createCampaign.create140'),
        ],
      },
      cancelRow: {},
      showMobile: false,
      reportType: 0,
      newTypes: [8, 9, 10, 11],
      popDiscount: 0,
      comboTypes:{},
      comboType:0,
      keys:{
        custom_review:'Custom Review',
        rating:'Rating',
        download:'Install',
      },
      socialMediaTypes:[16,17,18,19],
      offlineTypes: [14,15,16,17,18,19],
      offlineTypes2: [14,15,19],
      offlineTypesRow: {
        14: 'real_guaranteed_reviews',
        15: 'likes',
        16: 'social_media_follow_subscribe',
        17: 'social_media_post_like',
        18: 'social_media_review',
        19: 'google_maps_rating_review',
      },
      costPopRunType: '',
    }
  },
  created() {
    if (this.$route.query.package) {
      this.params.package = this.$route.query.package
    }
    this.initPage()
    window.addEventListener('resize', this.move)
    let width = document.body.clientWidth || document.documentElement.clientWidth
    this.showMobile = width < 1025
  },
  mounted() {
    document.getElementById('elMain').scrollTop = 0
  },
  destroyed() {
    window.removeEventListener('resize', this.move)
  },
  watch: {
    $route: function() {
      this.initPage()
    },
    isEnglish: {
      handler(newVal) {
        if(newVal){
          this.asoGrowOption = this.asoGrowOptionEN
        }else{
          this.asoGrowOption = this.asogrowCN
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    isSocialMediaType(business_type){
      return this.socialMediaTypes.includes(business_type)
    },
    renderKeysInOrder(obj,cp_type){  
      if(cp_type === 0){
        return obj
      }else{
        const order = ['download', 'rating', 'custom_review']; // 定义渲染顺序  
        let newObj = {}
        for (const key of order) {  
            if (!newObj.hasOwnProperty(key)) { // 确保对象包含该属性  
                // console.log(key + ': ' + obj[key]); // 或者其他渲染逻辑  
                newObj[key] = obj[key]
            }  
        }  
        return newObj
      }
    },  
    getTotalCap(arr){
      const total = arr.reduce((num, item) => {  
        return num + item.total_cap;  
      }, 0); 
      return total
    },
    // 导出数据
    exportAll() {
      this.loading = true
      this.$http
        .get('/api/campaign/', {
          params: {
            ...this.params,
            is_export: 1,
          },
        })
        .then(res => {
          this.loading = false
          const fileName = 'Campaign.csv';  
          let newData = this.handleExcelData(res)
          this.exportToCSV(newData, fileName,'csv');
          console.log(res,newData);
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    initPage() {
      this.getOptions()
      this.getList('init')
    },
    move() {
      let dom = document.getElementsByClassName('el-tooltip__popper')
      if (dom.length > 1) {
        dom[1].style.left = '0'
        dom[1].style.transformOrigin = 'center center'
      }
      let width = document.body.clientWidth || document.documentElement.clientWidth
      this.showMobile = width < 1025
    },
    handleVisible() {
      this.successVisible2 = false
      this.infoVisible = false
    },
    goCreate() {
      this.$router.push('/campaign/create')
    },
    reduceOptions(array){
      this.comboTypes = array.reduce((acc, cur) => {
        acc[cur.id] = cur.name;
        return acc;
      }, {});
    },
    getOptions() {
      this.$http
        .get('/api/data/settings/', {
          params: {
            fields: 'asogrow',
          },
        })
        .then(data => {
          if(this.isEnglish){
            this.asoGrowOption = data.data.asogrow
            this.asoGrowOptionEN = data.data.asogrow
          }else{
            this.asoGrowOption = this.asogrowCN
          }
          this.reduceOptions(this.asoGrowOption.asogrow_price_business_type)
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    getList(type) {
      this.loading = true
      if (this.params.cpid) {
        this.params.cpid = parseInt(this.params.cpid)
      }
      this.$http
        .get('/api/campaign/', {
          params: {
            ...this.params,
            p: this.page ? this.page.cur : 1,
            n: this.page ? this.page.per : 20,
          },
        })
        .then(data => {
          this.loading = false
          this.list = data.data.map(item => {
            item.promoteLoading = false
            return item
          })
          let { firstCreate, status } = this.$route.query
          if (status === '1' && firstCreate) {
            this.successVisible2 = true
            this.$router.replace('/campaign/list')
            this.$emit('refreshData')
          }
          if (status === '2' && firstCreate) {
            this.infoVisible = true
            this.$router.replace('/campaign/list')
            this.$emit('refreshData')
          }
          this.showTipId = this.getId(this.list)
          this.changePageItem(this.page, data)
          this.$nextTick(() => {
            const tooltips = document.getElementsByClassName('el-tooltip__popper')
            for (let i = 0, j = tooltips.length; i < j; i++) {
              if (i % 2 === 0) {
                tooltips[i].style.display = 'none'
              }
            }
          })

          type === 'init' && this.handleAction()
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    handleAction() {
      // /campaign/list?id=xxx&type=promote 跳转到列表页且打开对应cpid的promote确认弹窗
      // /campaign/list?id=xxx&type=consumption 跳转到列表页且打开对应cpid的campaign的消耗数据弹窗
      let { id, type } = this.$route.query
      if (id) {
        this.$http
          .get(`/api/campaign/${id}/`)
          .then(data => {
            let row = data.data
            if (type === 'promote') {
              this.promoteCheck(row)
            }
            if (type === 'consumption') {
              this.showCostReport(row)
            }
          })
          .catch(error => {
            this.notifyOpen('Error', this.executeError(error), 'error')
          })
      }
    },
    getId(data) {
      if (data.length === 0) {
        return null
      }
      let obj = null
      obj = data.find(item => item.status === 3)
      let id
      if (obj !== undefined) {
        id = obj.id
      }
      return id
    },
    add() {
      this.$router.push('/campaign/create')
    },
    repeat(row) {
      this.$router.push({ path: '/campaign/create', query: { type: 'repeat', id: row.id } })
    },
    postChangeStatus:throttleFn(function(row, params){
      this.$http
        .post(`/api/campaign/${row.id}/change_status/`, params)
        .then(data => {
          this.notifyOpen(this.$t('messages.createCampaign.create200'))
          row.status = params.status
          this.cancelVisible = false
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },3000),
    changeStatus(row, status) {
      if(row.run_type === 0){
        if (status === 6) {
          this.cancelVisible = true
          this.cancelRow = row
        } else {
          const params = {
            status: status,
          }
          this.postChangeStatus(row, params)
        }
      }else{
        let msg = this.$t('messages.createCampaign.create199')
        this.notifyOpen(this.$t('messages.createCampaign.create198'), msg, 'error')
      }
    },
    handleSubmit() {
      this.$refs.cancelCampaign.validate((valid, data) => {
        if (valid) {
          const params = {
            status: 6,
            cancel_reason: this.form.cancel_reason,
          }
          this.postChangeStatus(this.cancelRow, params)
        }
      })
    },
    promoteCheck(row) {
      this.promoteCampaign = row
      const params = {
        id: row.id,
      }
      row.promoteLoading = true
      this.$http
        .post('/api/campaign/check/', params)
        .then(data => {
          this.checkCampaign = data.data
          if (this.checkCampaign.need_recharge) {
            this.balanceNotEnough = true
          } else {
            this.balanceNotEnough = false
          }
          // 获取当前时间的时间戳
          // 比较当前时间戳和开始时间戳的大小
          this.handleShowTip()
          this.confirmVisible = true
          row.promoteLoading = false
        })
        .catch(error => {
          if(error.c){
            this.notifyOpen('Error', error.c, 'error')
          }else{
            this.notifyOpen('Error', this.executeError(error), 'error')
          }
          row.promoteLoading = false
        })
    },
    getTimeZ(tz) {
      let str = ''
      this.timezoneOptions.map(i => {
        if (Number(i.id) === Number(tz)) {
          str = i.name
        }
        return i
      })
      return str
    },
    getLocalTime(i) {
      if (typeof i !== 'number') return
      var d = new Date()
      // 得到1970年一月一日到现在的秒数
      var len = d.getTime()
      // 本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
      var offset = d.getTimezoneOffset() * 60000
      // 得到现在的格林尼治时间
      var utcTime = len + offset
      return new Date(utcTime + 3600000 * i)
    },
    handleShowTip() {
      let todayDate = this.getLocalTime(Number(this.promoteCampaign.tz)).setHours(0, 0, 0, 0)
      let paramsDate = new Date(this.promoteCampaign.start).setHours(0, 0, 0, 0)
      let isToday = todayDate === paramsDate
      let createTime = this.getLocalTime(Number(this.promoteCampaign.tz)).getHours()
      if (isToday && createTime >= 7) {
        this.rightNow = true
      } else {
        this.rightNow = false
        this.promoteCampaign.start =
          this.promoteCampaign.start.substr(0, 10) +
          ' 07:00:00' +
          `(${this.getTimeZ(this.promoteCampaign.tz)})`
      }
    },
    showCampaignDetail(id) {
      window.open(`/campaign/create?type=detail&id=${id}`, '_blank')
      // var winRef = window.open('','_blank');
      // winRef.location = `/campaign/create?type=detail&id=${id}`;
    },
    getCostDetail(row){
      this.costReportLoading = true
        this.$http
          .get(`/api/campaign/${row.id}/cost_detail/`)
          .then(data => {
            this.costReportLoading = false
            this.costReportData.total = data.data.total
            this.costReportData.cost = data.data.cost
            this.costReportData.cap = data.data.cap
            this.costReportData.file_url = data.data.file_url
            this.costReportData.discount_type = data.data.discount_type
            this.costReportData.consumed_cap = data.data.consumed_cap || {}
            this.costReportData.total_cap = data.data.total_cap || {}
            this.costReportData.use_total_price_discount = data.data.use_total_price_discount
            this.costReportData.consumption_process_dict = data.data.consumption_process_dict || {}
            this.costReportData.unit_price_process_dict = data.data.unit_price_process_dict || {}
            // console.log(this.costReportData.unit_price_process_dict);
          })
          .catch(err => {
            this.costReportLoading = false
            this.notifyOpen('Error', this.executeError(err), 'error')
          })
    },
    getCostDetailOffline(row){
      this.costReportLoading = true
        this.$http
          .get(`/api/campaign/${row.id}/cost_detail_v2/`)
          .then(data => {
            this.costReportLoading = false
            this.costReportData.file_url = data.data.report_link
            this.costReportData.discount_type = data.data.discount_type
            this.costReportData.consumed_cap = data.data.consumed_cap_v2 || {}
            this.costReportData.total_cap = data.data.total_cap_v2 || {}
            this.costReportData.use_total_price_discount = data.data.use_total_price_discount
            this.costReportData.consumption_process_dict = data.data.consumption_process_dict || {}
            this.costReportData.unit_price_process_dict = data.data.unit_price_process_dict || {}
            // console.log(this.costReportData.unit_price_process_dict);
          })
          .catch(err => {
            this.costReportLoading = false
            this.notifyOpen('Error', this.executeError(err), 'error')
          })
    },
    showCostReport(row) {
      let { country } = row
      this.costReportVisible = true
      this.costReport.id = row.id
      this.costReport.app_name = row.app_name
      this.popDiscount = row.real_time_discount
      this.comboType = row.cp_type
      this.costPopBusinessType = row.business_type
      this.costPopMediaPlatform = row.media_platform
      this.costPopMediaTarget = row.media_target
      this.costPopRunType = row.run_type
      if (!this.originalCountry.includes(country) && row.report_link) {
        this.costReportLink = row.report_link
        this.reportType = 1
      } else {
        this.reportType = 0
        if(row.run_type === 1){
          this.getCostDetailOffline(row)
        }else{
          this.getCostDetail(row)
        }
      }
    },
    showAction(status, action) {
      const actionMap = {
        repeat: [4, 5, 6, 7, 8, 9, 10],
        active: [5],
        pause: [4],
        cancel: [4, 5, 10],
        promote: [3],
      }
      return actionMap[action].includes(status)
    },
    downloadFileWithLink(fileUrl, fileName = '') {
      return new Promise((resolve) => {
        try {
          // 1. 创建隐藏的a标签
          const link = document.createElement('a');
          link.style.display = 'none'; // 隐藏a标签
          link.href = fileUrl; // 设置下载链接
          
          // 2. 设置下载属性（指定文件名，增强兼容性）
          if (fileName) {
            link.download = fileName;
          }
          
          // 3. 将a标签添加到DOM中（部分浏览器需要）
          document.body.appendChild(link);
          
          // 4. 模拟点击触发下载
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          link.dispatchEvent(clickEvent);
          
          // 5. 清理DOM元素
          setTimeout(() => {
            document.body.removeChild(link);
          }, 100);
          
          console.log('下载已触发');
          resolve(true);
        } catch (error) {
          console.error('download error：', error);
          resolve(false);
        }
      });
    },
    exportData(url) {
      // window.open(url, '_self')
      // var winRef = window.open('','_blank');
      // winRef.location =url;
      this.downloadFileWithLink(url)
        .then((success) => {
          if (success) {
            // 下载触发成功的提示（注意：无法判断文件是否真的下载完成）
            // alert('开始下载文件，请在浏览器下载栏查看');
          } else {
            console('下载触发失败，请检查网络或链接是否有效');
          }
        });
    },
    exportDatarReport() {
      const a = document.createElement('a')
      a.href = this.costReportLink
      a.target = '_parent'
      a.download = 'Export.xlsx' // 在这里补充了文件的后缀名
      ;(document.body || document.documentElement).appendChild(a)
      a.click()
      a.remove()
    },
    // promote
    viewCampaignList() {
      this.successVisible = false
      this.getList()
    },
    sumTotalCap() {
      let sum = 0
      this.promoteCampaign.info.forEach(item => {
        if (item.total_cap) {
          sum += item.total_cap
        }
      })
      return sum
    },
    goDeposit() {
      this.confirmVisible = false
      let need = this.checkCampaign.need
      window.open(`/deposit?need=${need}`, '_blank')
    },
    promoteCreate() {
      let params = {
        id: this.promoteCampaign.id,
      }
      this.$http
        .post('/api/campaign/promote/', params)
        .then(data => {
          this.confirmVisible = false
          this.successVisible = true
          // 触发获取弹窗信息
          setTimeout(() => {
            this.$store.dispatch('getRealTimeInfo')
          }, 2000)
        })
        .catch(error => {
          switch (error.c) {
            case -2001: // 余额不足
              this.confirmVisible = false
              this.failVisible = true
              break
            default:
              // network error
              this.notifyOpen('Error', this.executeError(error), 'error')
          }
        })
    },
  },
  filters: {
    dataFormat(data, num = 2) {
      if (typeof data !== 'number') {
        return data
      }
      if (Number(data) === 0) {
        return 0
      } else {
        return '$' + data.toFixed(num)
      }
    },
  },
  computed: {
    isEnglish(){
      return this.$i18n.locale === 'en'
    },
    btnDisabled() {
      return this.form.cancel_reason === '' || this.form.cancel_reason === undefined
    },
    isAgent(){
      return this.$store.state.profile.customer_type === 1
    },
    isOfflineTypeComputed(){
      let flag = this.offlineTypes.includes(this.costPopBusinessType) && this.comboType === 0
      return flag
    },
    isOfflineTypeComputed2(){
      let flag = this.offlineTypes2.includes(this.costPopBusinessType) && this.comboType === 0
      return flag
    },
  },
}
</script>

<style lang="scss">
.cancel-confirm {
  .cancel_reason {
    .el-form-item__label:before {
      display: none;
    }
  }
}
.el-link.el-link--primary {
  color: #1861f2;
}
.el-tooltip__popper.is-dark {
  background: #1861f2;
}
.el-tooltip__popper[x-placement^='bottom'] .popper__arrow::after {
  border-bottom-color: #1861f2;
}
.el-tooltip__popper[x-placement^='top'] .popper__arrow::after {
  border-top-color: #1861f2;
}
.dan:nth-of-type(odd) {
  display: none;
}

.info-confirm {
  .tip {
    font-size: 24px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 16px;
    text-align: center;
  }
  .tip2 {
    font-size: 16px;
    font-weight: 400;
    color: #1861f2;
    text-align: center;
  }
  .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 43px;
  }
  .el-button--primary {
    width: 128px;
    height: 32px;
    background: #1861f2;
    border-radius: 4px 4px 4px 4px;
  }
  .el-result {
    padding: 0;
  }
  .guide-a {
    color: #6b6d71 !important;
    padding: 0 !important;
  }
  .guide-a:hover {
    color: #1861f2 !important;
    text-decoration: none;
  }
}
.success-confirm {
  .tip {
    font-size: 24px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 16px;
    text-align: center;
  }
  .tip2 {
    font-size: 16px;
    font-weight: 400;
    color: #1861f2;
    text-align: center;
  }
  .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 43px;
  }
  .el-button--primary {
    width: 128px;
    height: 32px;
    background: #1861f2;
    border-radius: 4px;
  }
  .el-result {
    padding: 0;
  }
}
.tip-p {
  font-size: 13px;
  color: #909399;
}
.export-area {
  text-align: right;
}
.export-area2{
  text-align: right;
  >span{
    &:first-child{
      width: 100px;
      display: inline-block;
      margin-right: 20px;
    }
    &:last-child{
      color: #F65D5D;
      font-weight: 600;
    }
  }
}
.cost-link {
  text-decoration: underline;
}
.cost-link-d:hover{
  color: #1861f2;
  text-decoration: underline;
}
.info-tip {
  margin-top: 20px;
}
.campaign-list {
  margin-bottom: 24px;
  .cost-report-zhekou{
    color: #F65D5D;
    font-weight: 600;
    margin-top: 14px;
    >span{
      margin-right: 4px;
    }
  }
  a:hover {
    text-decoration: none;
  }
  .icon {
    width: 48px;
    height: 48px;
  }
  .icon1 {
    width: 24px;
    height: 24px;
  }
  .img-d{
    width: 48px;
    height: 48px;
    margin: 0 auto;
    line-height: 48px;
    text-align: center;
  }
  .cost-report {
    table {
      width: 100%;
      border: 1px solid #ebeef5;
      border-collapse: collapse;
    }
    th,
    td {
      border: 1px solid #ebeef5;
      text-align: center;
      padding: 4px;
    }
  }
  .el-loading-mask:after,
  .el-loading-mask:before {
    top: 65px;
  }
  .el-table__body {
    .expanded {
      .el-table__expand-icon > .el-icon {
        color: #1861f2;
      }
    }
  }
  .el-table__expand-icon > .el-icon {
    font-weight: bold;
  }
  .el-table__expanded-cell {
    padding: 16px !important;
  }
}

@media screen and (max-width: 1025px) {
  .campaign-list {
    .search-wrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .search-item {
        width: 50%;
        margin-bottom: 14px;
      }
      .search-item-btn {
        justify-content: space-between;
        display: flex;
        button {
          width: calc(50% - 10px);
          border-radius: 4px;
        }
        .create-btn{
          min-width: 132px;
        }
      }
    }
    .campaignListTable {
      .actionWrap {
        display: flex;
        flex-direction: column;
        a {
          margin-left: 0 !important;
        }
      }
    }
    .tableRow {
      margin-bottom: 30px !important;
    }
    .pagination {
      .el-select {
        min-width: 50px !important;
        margin-right: 4px !important;
        .select-label {
          font-size: 12px !important;
        }
        .el-input__inner {
          padding-right: 4px !important;
          padding-left: 4px !important;
        }
        .el-input__suffix {
          .el-input__suffix-inner {
            .el-icon-arrow-up:before {
              font-size: 12px !important;
            }
          }
        }
      }
      .el-row--flex {
        flex-direction: column-reverse;
        .left {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 28px;
        }
      }
      .el-pagination {
        .el-pager {
          li {
            min-width: 20px !important;
          }
        }
        .btn-prev {
          padding-right: 6px !important;
        }
        .btn-next {
          padding-left: 6px !important;
        }
      }
    }
  }
}
@media screen and (max-width: 736px) {
  .campaign-list {
    .search-item-btn{
      .el-button{
        min-width: 68px;
      }
    }
    .cost-report {
      .el-dialog {
        width: 9.0667rem !important;
      }
    }
    .campaign-confirm {
      .el-dialog {
        width: 8.6933rem !important;
      }
      .campaign-info {
        background: #f5f7fa;
        border-radius: 8px 8px 0 0;
        padding: 16px 16px 12px;
        margin-bottom: 0;
        .row {
          flex-direction: column;
          .label {
            text-align: left;
          }
          .value {
            color: #303133;
          }
        }
      }
      .balance-tips {
        padding: 16px;
        background: #f5f7fa;
        border-radius: 0 0 8px 8px;
      }
      .el-dialog__body {
        padding-bottom: 15px !important;
      }
    }
    .cost-report,
    .create-success,
    .create-fail,
    .success-confirm,
    .info-confirm,
    .cancel-confirm {
      .el-dialog {
        width: 340px !important;
      }
    }
    .campaignListTable {
      .el-table__header-wrapper {
        .el-table__header {
          th {
            .cell {
              // white-space: break-spaces !important;
            }
          }
        }
      }
      th.el-table__cell > .cell {
        white-space: break-spaces !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand /deep/ .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  // width: 50%;
  width: 100%;
  display: flex;
  align-items: center;
}
.demo-table-expand /deep/ .el-form-item__label {
  font-weight: 400;
  color: #303133;
  width: 120px;
  min-width: 120px;
}
/deep/ .el-table__body-wrapper {
  .el-table__expanded-cell {
    z-index: 100;
    padding: 0;
  }
  .el-table__expanded-cell:hover {
    background-color: #fff !important;
  }
}
.demo-table-expand /deep/.el-table__fixed-right {
  .el-table__expanded-cell {
    visibility: hidden;
    padding: 0;
  }
}
.demo-table-expand {
  // width: calc(100% - 300px);
  background: #fff; //盖住fixed产生的阴影
}
</style>
